// store/slices/uiSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UiState {
  viewMode: "list" | "grid";
}

const initialState: UiState = {
  viewMode: "list",
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setViewMode(state, action: PayloadAction<"list" | "grid">) {
      state.viewMode = action.payload;
    },
  },
});

export const { setViewMode } = uiSlice.actions;
export default uiSlice.reducer;
